import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NextaBaseList } from "../shared/nexta-crud/nexta-base-list";
import { NotificationService } from "../shared/notification.service";
import { Client } from "./client";
import { ClientService } from "./crud.service";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./client-list.component.html",
	standalone: false,
})
export class ClientListComponent extends NextaBaseList<Client> {
	constructor(
		router: Router,
		clientService: ClientService,
		notificationService: NotificationService,
		route: ActivatedRoute,
		cdr: ChangeDetectorRef,
	) {
		super(
			"/clients",
			router,
			clientService,
			notificationService,
			route,
			"clients",
			cdr,
		);
	}
}
